/* begin general import */
import { SemesterFilter } from "models/Semester";
import { StatusFilter } from "models/Status";
import React from "react";
import { useTranslation } from "react-i18next";
import { IdFilter, StringFilter } from "react3l-advanced-filters";
import { AdvanceDateRangeFilter, AdvanceIdFilter } from "react3l-ui-library";
import AdvanceStringFilter from "react3l-ui-library/build/components/AdvanceFilter/AdvanceStringFilter";
import Drawer, {
  DrawerProps,
} from "react3l-ui-library/build/components/Drawer/Drawer";
import { Reducer } from "redux";
import {
  FilterAction,
  filterReducer,
  filterService,
} from "services/page-services/filter-service";
import { semesterRepository } from "repositories/semester-repository";
import { GenderFilter } from "models/Gender";
import { MajorFilter } from "models/Major";

/* end individual import */

export interface SemesterFilterProps extends DrawerProps {
  filter?: any;
  setVisible?: any;
  handleChangeAllFilter?: (data: any) => void;
}

function SemesterAdvanceFilter(props: SemesterFilterProps) {
  const [translate] = useTranslation();

  const { visible, filter, setVisible, handleChangeAllFilter, handleClose } =
    props;

  const [modelFilter, setModelFilter] = React.useReducer<
    Reducer<SemesterFilter, FilterAction<SemesterFilter>>
  >(filterReducer, filter);

  const { handleChangeInputFilter, handleChangeDateFilter } =
    filterService.useFilter(filter, setModelFilter);

  const handleSaveModelFilter = React.useCallback(() => {
    handleChangeAllFilter(modelFilter);
    setVisible(false);
  }, [handleChangeAllFilter, modelFilter, setVisible]);

  const handleClearModelFilter = React.useCallback(() => {
    setModelFilter({
      type: 0,
      payload: new SemesterFilter(),
    });
  }, [setModelFilter]);

  return (
    <Drawer
      visible={visible}
      handleSave={handleSaveModelFilter}
      handleCancel={handleClearModelFilter}
      handleClose={handleClose}
      visibleFooter={true}
      loading={false}
      size={"sm"}
      title={translate("general.drawer.filter")}
      titleButtonCancel={translate("general.actions.clear")}
      titleButtonApply={translate("general.actions.apply")}
    >
      <div className="d-flex m-t--sm">
        <AdvanceStringFilter
          label={translate("semesters.code")}
          maxLength={100}
          value={modelFilter["code"]["contain"]}
          onChange={handleChangeInputFilter({
            fieldName: "code",
            fieldType: "contain",
            classFilter: StringFilter,
          })}
          placeHolder={translate("semesters.placeholder.code")}
          showCount
        />
      </div>

      <div className="d-flex m-t--sm">
        <AdvanceStringFilter
          label={translate("semesters.name")}
          maxLength={100}
          value={modelFilter["name"]["contain"]}
          onChange={handleChangeInputFilter({
            fieldName: "name",
            fieldType: "contain",
            classFilter: StringFilter,
          })}
          placeHolder={translate("semesters.placeholder.name")}
          showCount
        />
      </div>

      <div className="d-flex m-t--sm">
        <AdvanceDateRangeFilter
          label={translate("semesters.startedAt")}
          onChange={handleChangeDateFilter({
            fieldName: "startedAt",
            fieldType: ["greaterEqual", "lessEqual"],
          })}
          value={[
            modelFilter?.startedAt?.greaterEqual as any,
            modelFilter?.startedAt?.lessEqual as any,
          ]}
          type={1}
          placeholder={[
            translate("general.filter.startDate"),
            translate("general.filter.endDate"),
          ]}
        />
      </div>

      <div className="d-flex m-t--sm">
        <AdvanceDateRangeFilter
          label={translate("semesters.endedAt")}
          onChange={handleChangeDateFilter({
            fieldName: "endedAt",
            fieldType: ["greaterEqual", "lessEqual"],
          })}
          value={[
            modelFilter?.endedAt?.greaterEqual as any,
            modelFilter?.endedAt?.lessEqual as any,
          ]}
          type={1}
          placeholder={[
            translate("general.filter.startDate"),
            translate("general.filter.endDate"),
          ]}
        />
      </div>
    </Drawer>
  );
}

export default SemesterAdvanceFilter;
